import React, { useState } from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import { css } from 'styled-components';
import { Small } from '../Typography';
import DropDown from '../DropDown';
import Label from '../Label';
import { FlexMiddle } from '../Flex';
import { MockFiltersRow } from '../FiltersRow';
import MockFilterOptions from './MockFilterOptions';

const ErrorText = styled(Small)`
  color: ${({ theme }) => theme.colors.redNegative};
`;

const ClickableContainerWrapper = styled(FlexMiddle)`
  cursor: pointer;
  position: relative;
  border-radius: 4px;
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.colors.grey2};
  outline: 0;
  background: ${({ theme }) => theme.colors.white};
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      background: ${({ theme }) => theme.colors.grey1};
      cursor: not-allowed;
    `};

  .error-text-wrapper {
    position: absolute;
    bottom: -15px;
  }

  ${({ theme, error }) => error && `border-color: ${theme.colors.redNegative};`}

  ${({ theme, isActive }) => isActive && `border: 1px solid ${theme.colors.primary};`}

  &:hover, &:focus {
    border: 1px solid ${({ theme }) => theme.colors.grey3};
  }

  ${({ $noBorder }) =>
    $noBorder &&
    `border: none;
    &:hover, &:focus {
      border: none;
      }
  `}

  .drop-down-arrow {
    transform: rotate(${({ isActive }) => (isActive ? 270 : 90)}deg);
    transition: 200ms;
    min-width: 12px;
    path {
      fill: ${({ theme }) => theme.colors.grey4};
    }
  }
`;

const MockFilter = ({
  selectedKey,
  filterContextParams,
  setFilters,
  error,
  openFromRight,
  externalOptions,
  title = '',
  required = false,
  className,
  filters = {},
  maxHeight,
  disabledFilters = [],
  showIcon = true,
  isDisabled = false,
  disableTooltip = false,
  doApiCall = true
}) => {
  const [search, setSearch] = useState('');

  return (
    <Label title={title} required={required} className={className}>
      {error && (
        <ErrorText>
          <Trans>{error}</Trans>
        </ErrorText>
      )}
      <DropDown
        showArrow
        usePortal
        maxHeight={maxHeight}
        isMenuTriggerWidth
        openFromRight={openFromRight}
        clickableContainer={ClickableContainerWrapper}
        renderValue={({ isOpen }) => (
          <MockFiltersRow
            search={search}
            title={title}
            setSearch={setSearch}
            selectedKey={selectedKey}
            filters={filters}
            setFilters={setFilters}
            disabledFilters={disabledFilters}
            isOpen={isOpen}
            externalOptions={externalOptions}
            doApiCall={doApiCall}
            showIcon={showIcon}
            isDisabled={isDisabled}
            disableTooltip={disableTooltip}
          />
        )}>
        <MockFilterOptions
          showSearchBox={showIcon}
          hasClear={false}
          search={search}
          setSearch={setSearch}
          selectedKey={selectedKey}
          filters={filters}
          setFilters={setFilters}
          disabledFilters={disabledFilters}
          filterContextParams={filterContextParams}
          externalOptions={externalOptions}
          doApiCall={doApiCall}
        />
      </DropDown>
    </Label>
  );
};

export default MockFilter;
